import m from "../../../../geodata/es2015/region/usa/txLow";
window.am4geodata_region_usa_txLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/txLow.js
// module id = null
// module chunks = 